<template>
    <b-modal
        ref="petcareOnboardingModal"
        lazy
        title-tag="h2"
        :title="title"
        no-close-on-esc
        no-close-on-backdrop
        no-enforce-focus
    >
        <div class="container-fluid">
            <div class="row-fluid">
                <p>
                    This add-on enables the `PetCare by DaySmart` Vet client
                    app. Once enabled, clients can access their information,
                    including their pet's medical records, reminders, and
                    appointments, through the mobile app available on the Apple
                    App Store and the Google Play Store, as well as the web app
                    for convenient access from any browser.
                </p>
            </div>
            <div
                class="row-fluid"
                style="
                    border-top: 1px solid #ddd;
                    padding-top: 10px;
                    margin-top: 10px;
                "
            >
                <b-form>
                    <div v-if="!isLoaded">
                        <img
                            src="assets/ajax-loader.gif"
                            style="padding: 10px;"
                        />
                    </div>
                    <b-form-group
                        :label-for="`payment_method_name`"
                        :label-cols="formColumn"
                        label="Payment Method:"
                        v-else
                    >
                        <vet-select
                            v-if="primaryPaymentMethod === null"
                            id="payment_method_name"
                            :key="payment_method.id"
                            v-model="payment_method.name"
                            v-validate="'required'"
                            :class="{
                                'border-danger': errors.has(
                                    'payment_method_name'
                                )
                            }"
                            module="petcare-onboarding-payment-method"
                            placeholder="Payment Method (required)"
                            name="payment_method_name"
                            @toggle-spinner="receiveEmitSpinner"
                            @refresh-primary-payment="receiveEmitPrimaryPayment"
                        />
                        <div class="h-100 d-flex align-items-center" v-else>
                            <span>{{ primaryPaymentMethodDisplay }}</span>
                        </div>
                    </b-form-group>
                </b-form>
            </div>
        </div>

        <template v-slot:modal-footer="{ cancel }">
            <b-button class="mr-auto" variant="secondary" @click="cancel">
                Cancel
            </b-button>

            <div>
                <div v-if="loading">
                    <img src="assets/ajax-loader.gif" style="padding: 10px;" />
                </div>
                <b-button v-else variant="primary" @click="submit">
                    Enable
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import vetSelect from "@/module/commons/vet-select.vue";
import PaymentDialogHelper from "@/module/payment/helper.js";
import subscriptionService from "@/services/subscription";
import EXTENSIONS from "@/constants/extensions";
import Account from "@/services/account.js";

export default {
    props: {},
    components: {
        vetSelect
    },
    mixins: [PaymentDialogHelper],
    data() {
        return {
            isLoaded: false,
            title: "Enable Add-On",
            payment_method: {
                id: null,
                name: null
            },
            primaryPaymentMethod: null,
            loading: false
        };
    },
    mounted() {},
    watch: {},
    computed: {
        formColumn() {
            return this.col ? this.col : 4;
        },
        primaryPaymentMethodDisplay() {
            if (!this.primaryPaymentMethod) {
                return "";
            }

            if (
                this.primaryPaymentMethod &&
                this.primaryPaymentMethod.last_four_digit
            ) {
                return `${this.primaryPaymentMethod.card_network} xxx${this.primaryPaymentMethod.last_four_digit}`;
            }

            if (this.primaryPaymentMethod && this.primaryPaymentMethod.name) {
                return `${this.primaryPaymentMethod.card_network} ${this.primaryPaymentMethod.name}`;
            }

            return `${this.primaryPaymentMethod.card_network}`;
        }
    },
    methods: {
        async open() {
            this.$refs.petcareOnboardingModal.show();
            await this.getPrimaryPaymentMethod();
        },
        async getPrimaryPaymentMethod() {
            try {
                this.isLoaded = false;
                const response = await subscriptionService.getPrimaryPaymentMethod();
                if (
                    response &&
                    response.message &&
                    response.message.code == 200 &&
                    response.resource
                ) {
                    this.primaryPaymentMethod = response.resource;
                }
            } catch (error) {
                return;
            } finally {
                this.isLoaded = true;
            }
        },
        async submit() {
            var body = {
                source: EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP,
                business_id: this._setting.business_id,
                payment_method_id: this.primaryPaymentMethod.id
            };
            this.loading = true;
            try {
                const response = await Account.enableAddOn(body);
                if (
                    response &&
                    response.message &&
                    response.message.code == 200 &&
                    response.resources.success
                ) {
                    this._message(response.message.description, "success");
                    this.$router.push({
                        name: "petcare"
                    });
                } else {
                    this._message(response.message.description, "danger");
                }
            } catch (error) {
                this._message(error.message, "danger");
            } finally {
                this.loading = false;
                this.$refs.petcareOnboardingModal.hide();
            }
        },
        receiveEmitSpinner(value) {
            this.loading = value;
        },
        receiveEmitPrimaryPayment() {
            this.getPrimaryPaymentMethod();
        }
    }
};
</script>
